export default __webpack_public_path__ + "a8286faf7fc45257db4eb1e064c4cf67.png";